module.exports = __webpack_public_path__ + "static/assets/36220da60d9a9e1ba71f4e4004a2366f.svg";